import { Component, h } from 'preact';

import { MortgageComponentPropsInterface } from 'common/module/mortgage/component-props.interface';
import { MortgageCampaignLoaderService } from 'common/service/mortgage-campaign-loader/service';

/**
 * Component for rendering mortgage campaigns into dynamic templates
 */
export class MortgageComponent extends Component<MortgageComponentPropsInterface> {
  /**
   * @inheritDoc
   */
  public componentDidMount(): void {
    MortgageCampaignLoaderService()
      .load(this.props.campaignId)
      .then((view) => {
        view.initialize({
          element: this.base as HTMLElement,
          propertyModel: this.props.model,
          loanConfig: this.props.loanConfig,
        });

        view.render();
      })
      .catch((e) => console.warn(e));
  }

  /**
   * @inheritDoc
   */
  public shouldComponentUpdate(): false {
    // Do not update component's template
    return false;
  }

  /**
   * @inheritDoc
   */
  public render(): preact.JSX.Element {
    return <div className='mortgage_wrapper' />;
  }
}
